import type { Theme } from '@mui/material';
import { filledInputClasses } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { mediumSize, smallSize } from '@/mui/components/constants';

const inputFontSize = 14;
const inputSmallFontSize = 13;

export default function MUIFilledInput(theme: Theme): Components['MuiFilledInput'] {
  return {
    styleOverrides: {
      root: {
        borderRadius: theme.shape.borderRadius,
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(3),
        fontSize: inputFontSize,
        transitionProperty: 'border-radius',
        transitionDuration: '0.5s',
        backgroundColor: theme.palette.shades[200],

        '&:hover': {
          backgroundColor: theme.palette.shades[200],
          '&:before': {
            opacity: 1,
          },
        },

        '&:before': {
          left: 4,
          right: 4,
          opacity: 0,
          borderBottomColor: theme.palette.shades[700],
        },

        '&:after': {
          left: 4,
          right: 4,
          borderBottomColor: theme.palette.primary.main,
        },

        '&.Mui-disabled': {
          backgroundColor: theme.palette.shades[100],

          '&:before': {
            opacity: 0,
          },
          '&:after': {
            opacity: 0,
          },
        },
      },
      sizeSmall: {
        fontSize: inputSmallFontSize,
      },
      inputSizeSmall: {
        height: smallSize,
        fontSize: 13,
      },
      input: {
        padding: theme.spacing(0, 3, 0, 3),
        lineHeight: 1.4,
        height: mediumSize,
        fontSize: 14,
        '&:-webkit-autofill': {
          border: '0',
          WebkitTextFillColor: theme.palette.text.primary,
          WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.shades[200]} inset`,
          transition: 'background-color 5000s ease-in-out 0s',
        },
        '&:-webkit-autofill:hover': {
          border: '0',
          WebkitTextFillColor: theme.palette.text.primary,
          WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.shades[200]} inset`,
          transition: 'background-color 5000s ease-in-out 0s',
        },
        '&:-webkit-autofill:focus': {
          border: '0',
          WebkitTextFillColor: theme.palette.text.primary,
          WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.shades[200]} inset`,
          transition: 'background-color 5000s ease-in-out 0s',
        },

        [`&.${filledInputClasses.disabled}`]: {
          color: theme.palette.text.secondary,
          WebkitTextFillColor: theme.palette.text.secondary,
        },
      },
    },
  };
}
